import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/usps': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M460.3 241.7c-1.4 2.2-4.3 4.4-3.8-0.1 2.9-11.6 13.9-30.5 4.4-32-17.8-3.1-88.1 4.5-88.1 0 0-2.4 26.7-3.1 37.9-8.7 9.4-9.4 10.8-8 10.9-8h27c26.9 0 37.5 7.5 11.7 48.8zM348.2 264.3c-62.3 21.2-124.8 54.2-321.2 151.5l52.4-245.5c185 0 335.2-5.6 337.9 22.6h-196.6l30.7 93.3c35-16.8 120.9-51.7 172.6-53.9 21.8-0.8 30.6 2.9 26.2 5.8-4.7 2.3-38 4.9-102 26.2zM94.7 96h454.3l-67.7 319.7h-423.1s402-157.3 406.4-160.2c0 0 35.7-48 14.6-67.7-6.5-6.6-16-6.6-52.4-6.6-2.1-19.5-78.8-31.5-332.1-85.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/usps.js
// module id = 1073
// module chunks = 0